import { getKeitaroClickSubid, persistKeitaroClickSubid } from "./trackingStorage";
import { isIosDevice } from "./telegramPwa";

const SENT_KEY = "installPostbackSent";
const LAST_SUBID_KEY = "installPostbackLastSubid";

function wasInstallPostbackSent(subid) {
  try {
    if (localStorage.getItem(SENT_KEY) !== "1" || !subid) {
      return false;
    }
    return localStorage.getItem(LAST_SUBID_KEY) === subid;
  } catch {
    return false;
  }
}

function claimInstallPostback(subid) {
  if (!subid || wasInstallPostbackSent(subid)) {
    return false;
  }
  try {
    localStorage.setItem(SENT_KEY, "1");
    localStorage.setItem(LAST_SUBID_KEY, subid);
  } catch {
    return false;
  }
  return true;
}

function buildQuery(subid) {
  return `subid=${encodeURIComponent(subid)}&status=install`;
}

/**
 * Постбек у Keitaro у фоні (без редіректу сторінки).
 */
export function fireInstallPostbackOnDownload() {
  if (typeof window === "undefined") {
    return false;
  }

  persistKeitaroClickSubid();
  const subid = getKeitaroClickSubid();

  if (!subid || !claimInstallPostback(subid)) {
    return false;
  }

  const origin = window.location.origin;
  const url = `${origin}/keitaro-postback.php?${buildQuery(subid)}&_ts=${Date.now()}`;

  if (navigator.sendBeacon) {
    try {
      navigator.sendBeacon(url);
    } catch {
      /* ignore */
    }
  }

  const img = new Image();
  img.referrerPolicy = "no-referrer-when-downgrade";
  img.src = url;

  fetch(url, {
    method: "GET",
    cache: "no-store",
    credentials: "same-origin",
    keepalive: true,
  }).catch(() => {});

  return true;
}

/**
 * Android/Chrome: подія appinstalled = юзер реально встановив PWA.
 * На iOS постбек не надсилаємо.
 */
export function initInstallPostback() {
  if (typeof window === "undefined" || isIosDevice()) {
    return () => {};
  }

  persistKeitaroClickSubid();

  const onInstalled = () => {
    fireInstallPostbackOnDownload();
  };

  window.addEventListener("appinstalled", onInstalled);

  return () => {
    window.removeEventListener("appinstalled", onInstalled);
  };
}
